import { Icon } from "antd";
import React from "react";
import moment from "moment";

const periodSettings = {
	showTime: true,
	className: "period_input",
	suffixIcon: <Icon type="calendar" style={{ color: "black" }} />,
	format: "DD.MM.YYYY HH:mm",
	disabledDate: (date) => {
		return !date?.isAfter(moment()) && !date?.isSame(moment(), "day");
	},
	allowClear: false,
};

export default periodSettings;
